<div style="overflow: auto; height: calc(100vh - 220px)">
    <p class="text-muted small mt-2">
        These are suggestions and are not saved. A shared part number is the strongest match, then the same description, then a close
        description. Price gap is the difference between the highest and lowest median in the shared unit family.
        @if (note) {
            {{ note }}
        }
    </p>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="groupGrid"></action-toolbar-count>
                <grid-export [grid]="gridSimilarGroups" [name]="'Purchased Material Similar Items'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="groupGrid"></grid-column-group>
    <wj-flex-grid
        id="gridSimilarGroups"
        #gridSimilarGroups
        style="height: 320px"
        [isReadOnly]="true"
        (initialized)="groupGrid.initialize(gridSimilarGroups)"
        (destroy)="groupGrid.destroy()"
        (selectionChanged)="showMembers()"
        [itemsSource]="groupGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Item'" [binding]="'representative'" [width]="360" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Reason'" [binding]="'reason'" [width]="170" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Confidence'" [binding]="'confidence'" [width]="110" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Vendors'" [binding]="'vendorCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Unit'" [binding]="'unitFamily'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Low median'" [binding]="'lowMedian'" [width]="120" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'High median'" [binding]="'highMedian'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Price gap'" [binding]="'priceGap'" [width]="120" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridSimilarGroups"></grid-selection-calculation>

    <h5 class="mt-3">Selected suggestion</h5>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="memberGrid"></action-toolbar-count>
                <grid-export [grid]="gridSimilarMembers" [name]="'Purchased Material Similar Item Members'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="memberGrid"></grid-column-group>
    <wj-flex-grid
        id="gridSimilarMembers"
        #gridSimilarMembers
        style="height: 240px"
        [isReadOnly]="true"
        (initialized)="memberGrid.initialize(gridSimilarMembers)"
        (destroy)="memberGrid.destroy()"
        [itemsSource]="memberGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="360" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Vendor'" [binding]="'vendor'" [width]="220" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Part number'" [binding]="'partNumber'" [width]="150" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Unit'" [binding]="'unit'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Median unit price'" [binding]="'medianUnitPrice'" [width]="160" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridSimilarMembers"></grid-selection-calculation>
</div>
